enum InventoryUpdateReferenceColEnum {
    SKU = "sku",
    ITEM_GUID = "item_guid",
}

export default InventoryUpdateReferenceColEnum;
